function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n\t\t\t\t", "\n\t\t\t"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { html, protectedFields } from 'ovee.js';
var DEFAULT_SLOT_NAME = 'default'; // eslint-disable-next-line import/prefer-default-export

export function WithSlots(Ctor) {
  var _protectedFields$BEFO;

  _protectedFields$BEFO = protectedFields.BEFORE_INIT;

  // eslint-disable-next-line no-shadow
  var WithSlots = /*#__PURE__*/function (_Ctor) {
    _inherits(WithSlots, _Ctor);

    var _super = _createSuper(WithSlots);

    function WithSlots() {
      var _this;

      _classCallCheck(this, WithSlots);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _defineProperty(_assertThisInitialized(_this), "slots", {});

      return _this;
    }

    _createClass(WithSlots, [{
      key: _protectedFields$BEFO,
      value: function value() {
        this.initSlots();

        _get(_getPrototypeOf(WithSlots.prototype), protectedFields.BEFORE_INIT, this).call(this);
      }
    }, {
      key: "initSlots",
      value: function initSlots() {
        var _this2 = this;

        var _loop = function _loop() {
          var node = _Array$from[_i];
          var slotName = node instanceof Element && node.getAttribute('slot') || DEFAULT_SLOT_NAME;

          if (node instanceof HTMLTemplateElement) {
            node.content.childNodes.forEach(function (child) {
              return _this2.addToSlot(slotName, child);
            });
          } else {
            _this2.addToSlot(slotName, node);
          }
        };

        // eslint-disable-next-line no-restricted-syntax
        for (var _i = 0, _Array$from = Array.from(this.$element.childNodes); _i < _Array$from.length; _i++) {
          _loop();
        }
      }
    }, {
      key: "addToSlot",
      value: function addToSlot(name, node) {
        if (!this.slots[name]) {
          this.slots[name] = [];
        }

        this.slots[name].push(node);
      }
    }, {
      key: "slot",
      value: function slot() {
        var _this$slots$name;

        var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';
        var slots = (_this$slots$name = this.slots[name]) !== null && _this$slots$name !== void 0 ? _this$slots$name : [];
        return html(_templateObject(), slots);
      }
    }]);

    return WithSlots;
  }(Ctor);

  return WithSlots;
}